module.exports = {
  "icon-font": {
    "color": "#616C73"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-c7d6ec5c!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-icon/index.vue
// module id = 537
// module chunks = 0 1